import React, { useState, useEffect } from 'react'
import { Modal, Form, Button, Alert, Row, Col } from 'react-bootstrap'
import {
  useCreateAdminPermissionValue,
  useUpdateAdminPermissionValue
} from 'api/hooks/use-admin-permission-values'

const PermissionValueModal = ({ show, onHide, permissionId, permissionValue }) => {
  const isEditing = !!permissionValue

  const createMutation = useCreateAdminPermissionValue({
    permissionId,
    options: { onSuccess: () => onHide() }
  })
  const updateMutation = useUpdateAdminPermissionValue({
    id: permissionValue?.id,
    permissionId,
    options: { onSuccess: () => onHide() }
  })

  const [formData, setFormData] = useState({
    value: '',
    value_caption: '',
    is_conflict: false,
    is_expansive: false,
    weight: ''
  })

  useEffect(() => {
    if (permissionValue) {
      setFormData({
        value: permissionValue.value || '',
        value_caption: permissionValue.value_caption || '',
        is_conflict: permissionValue.is_conflict || false,
        is_expansive: permissionValue.is_expansive || false,
        weight: permissionValue.weight ?? ''
      })
    } else {
      setFormData({ value: '', value_caption: '', is_conflict: false, is_expansive: false, weight: '' })
    }
  }, [permissionValue, show])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const submitData = { ...formData }
    if (submitData.weight === '') submitData.weight = null
    if (isEditing) {
      updateMutation.mutate(submitData)
    } else {
      createMutation.mutate(submitData)
    }
  }

  const error = createMutation.error || updateMutation.error
  const isSubmitting = createMutation.isLoading || updateMutation.isLoading

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{isEditing ? 'Edit Permission Value' : 'Add Permission Value'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger">{error.message || 'An error occurred'}</Alert>}

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Value</Form.Label>
                <Form.Control type="text" name="value" value={formData.value} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Value Caption</Form.Label>
                <Form.Control type="text" name="value_caption" value={formData.value_caption} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Weight</Form.Label>
            <Form.Control type="number" name="weight" value={formData.weight} onChange={handleChange} />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Check type="checkbox" name="is_conflict" label="Is Conflict" checked={formData.is_conflict} onChange={handleChange} className="mb-3" />
            </Col>
            <Col md={6}>
              <Form.Check type="checkbox" name="is_expansive" label="Is Expansive" checked={formData.is_expansive} onChange={handleChange} className="mb-3" />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light-primary" onClick={onHide}>Cancel</Button>
          <Button type="submit" variant="primary" disabled={isSubmitting}>
            {isSubmitting ? 'Saving...' : isEditing ? 'Update' : 'Create'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default PermissionValueModal
